import { Component } from 'react';
class ContactInfo extends Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL + '/';

    return (
      <div className="ltn__contact-address-area mb-90">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-4">
              <div className="ltn__contact-address-item ltn__contact-address-item-2 box-shadow">
                <div className="ltn__contact-address-icon">
                  <img src={publicUrl + 'assets/img/icons/10.png'} alt="email" />
                </div>
                <h3>Email Address</h3>
                <p>
                  info@theapartmentdirectories.com <br />{' '}
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="ltn__contact-address-item ltn__contact-address-item-2 box-shadow">
                <div className="ltn__contact-address-icon">
                  <img src={publicUrl + 'assets/img/icons/11.png'} alt="phone" />
                </div>
                <h3>Phone Number</h3>
                <p>+1 (310) 708-2998</p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="ltn__contact-address-item ltn__contact-address-item-2 box-shadow">
                <div className="ltn__contact-address-icon">
                  <img src={publicUrl + 'assets/img/icons/12.png'} alt="address" />
                </div>
                <h3>Office Address</h3>
                <p>
                  {' '}
                  12121 Wilshire Blvd, Suite 1201
                  <br />
                  Los Angeles, CA 90025
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ContactInfo;
